import { Pipe, PipeTransform } from '@angular/core';
import { estadoBolsa } from '../components/api/models/allEnums';

@Pipe({
  name: 'estadoBolsa'
})
export class EstadoBolsaPipe implements PipeTransform {

   transform(value: estadoBolsa | string | undefined): string {
      if (value === undefined || value === null) {
        return 'Desconhecido';
      }
      return estadoBolsaDescriptions[value as estadoBolsa] || 'Desconhecido';
    }

}

export const estadoBolsaDescriptions: { [key in estadoBolsa]: string } = {
  [estadoBolsa.Ativo]: "Activo",
  [estadoBolsa.Inativo]: "Inactivo",
  [estadoBolsa.Suspenso]: "Suspenso",
  [estadoBolsa.Finalizado]: "Finalizado",
  [estadoBolsa.Pendente]: "Pendente",
  
};
